import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import WhatsAppFloat from "./WhatsAppFloat";
import CookieBanner from "./CookieBanner";
import PushPrompt from "./PushPrompt";
import { PromoBanner } from "@/pages/Promotions";

export default function PublicLayout() {
  return (
    <div className="min-h-screen flex flex-col" style={{ background: "var(--ct-bg)" }}>
      <a
        href="#main"
        className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 focus:z-[100] focus:px-4 focus:py-2 focus:rounded focus:font-medium focus:shadow-lg"
        style={{ background: "var(--ct-gold)", color: "#0D1B2A" }}
      >
        Sari la conținut
      </a>
      <PromoBanner />
      <Header />
      <main id="main" tabIndex={-1} className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <WhatsAppFloat />
      <CookieBanner />
      <PushPrompt />
    </div>
  );
}
